import React, { Component } from 'react';
import { Button, ButtonDropdown, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Input, Label, Row, Table } from 'reactstrap';
import Api from '../Api';
import SendStatus from './SendStatus';

class RsvpDropdown extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      dropdownOpen: false,
      value: this._rsvpDisplayText(this.props.guest.rsvp),
    };
  }

  _rsvpDisplayText(rsvp) {
    if (rsvp === 'going') return 'Yes';
    if (rsvp === 'not-going') return 'No';
    return 'Not Sure';
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  chooseRsvp = e => {
    const value = e.target.dataset.rsvpValue;
    this.props.guest.rsvp = value;
    this.setState({
      sendStatus: 'sending',
      value: this._rsvpDisplayText(value),
    });
    Api.setGuestRsvp(this.props.guest.guest_id, value)
      .then(response => {
        this.setState({
          sendStatus: response.error ? 'error' : 'sent',
        });
      });
  };

  render() {
    return (
      <div className="rsvp-dropdown">
        <SendStatus sendStatus={this.state.sendStatus} style={{display: 'inline-block'}}/>
        <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle caret style={{fontSize: '115%'}}>
            {this.state.value}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem data-rsvp-value="going" onClick={this.chooseRsvp}>Yes</DropdownItem>
            <DropdownItem data-rsvp-value="not-going" onClick={this.chooseRsvp}>No</DropdownItem>
            <DropdownItem data-rsvp-value="invited" onClick={this.chooseRsvp}>Not Sure</DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
      </div>
    );
  }
}

class MealForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      dietaryNotes: this.props.guest.dietary_notes,
      mealChoiceDropdownOpen: false,
      mealChoiceValue: this._mealChoiceDisplayText(this.props.guest.meal_choice),
    };
  }

  componentDidMount() {
    this._updateInputValues();
  }

  componentWillReceiveProps(newProps) {
    this._updateInputValues();
  }

  _updateInputValues() {
    if (!this.props.guest) {
      return;
    }
    this.setState({
      dietaryNotes: this.props.guest.dietary_notes,
    });
  }

  toggleMealChoiceDropdown = () => {
    this.setState({
      mealChoiceDropdownOpen: !this.state.mealChoiceDropdownOpen
    });
  }

  _mealChoiceDisplayText(mealChoice) {
    return mealChoice || 'Not Set';
  }

  chooseMeal = e => {
    const value = e.target.dataset.mealValue;
    this.setState({
      mealChoice: value,
      mealChoiceValue: this._mealChoiceDisplayText(value),
    });
  }

  _handleNotesChange = value => {
    this.setState({
      dietaryNotes: value,
    });
  }

  _handleSubmit = e => {
    e.preventDefault();
    const data = {
      meal_choice: this.state.mealChoice,
      dietary_notes: this.state.dietaryNotes,
    };
    this.setState({
      sendStatus: 'sending',
    });
    Api.putGuestInfo(this.props.guest.guest_id, data)
      .then(response => {
        if (response.error) {
          alert('There was a problem saving your meal choice. Please try again.');
        }
        this.setState({
          sendStatus: response.error ? 'error' : 'sent',
        });
      });
  }

  render() {
    return (
      <Form
        className="mt-2 pl-4 pt-3 pr-3"
        style={{
          backgroundColor: 'rgba(220, 225, 227, .25)',
          border: '1px solid rgba(0,0,0,0)',
          borderRadius: '2pt',
        }}
        onSubmit={this._handleSubmit}
      >
        <FormGroup row>
          <Label sm={5} size="md">Meal</Label>
          <Col sm={7} className="">
            <ButtonDropdown isOpen={this.state.mealChoiceDropdownOpen} toggle={this.toggleMealChoiceDropdown}>
              <DropdownToggle caret>
                {this.state.mealChoiceValue}
              </DropdownToggle>
              <DropdownMenu>
                {this.props.mealChoices.map(mealChoice => (
                  <DropdownItem key={mealChoice} data-meal-value={mealChoice} onClick={this.chooseMeal}>
                    {mealChoice}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </ButtonDropdown>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label sm={5}>Dietary Notes</Label>
          <Col sm={7} className="text-right">
            <Input
              type="text"
              placeholder="None"
              value={this.state.dietaryNotes}
              onChange={e => this._handleNotesChange(e.target.value)}
            />
          </Col>
        </FormGroup>
        <FormGroup row className="justify-content-end">
          <Col xs={0} sm={5} className="text-right">
            <SendStatus sendStatus={this.state.sendStatus} style={{marginTop:'.35rem'}}/>
          </Col>
          <Col xs={12} sm={7} className="">
            <Button
              color="secondary"
              size="md"
              type="submit"
              style={{paddingBottom:'.2rem'}}
            >Save</Button>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

const RsvpTableRow = ({ guest, mealChoices }) => (
  <tr>
    <td className="align-middle">
      <Row>
        <Col xs={7}>
          <Label className="align-middle col-form-label" style={{fontSize: '115%'}}>
            {guest.first_name} {guest.last_name}
          </Label>
        </Col>
        <Col xs={5} className="text-right">
          <RsvpDropdown guest={guest}/>
        </Col>
      </Row>
      {guest.rsvp !== 'going' ? null : <MealForm guest={guest} mealChoices={mealChoices}/>}
    </td>
  </tr>
);

const RsvpTable = ({ guests, mealChoices }) => (
  <Table className="mb-0">
    <tbody>
      {guests.map(guest => (
        <RsvpTableRow
          key={'guest-rsvp-'+guest.guest_id}
          guest={guest}
          mealChoices={mealChoices}
        />
      ))}
    </tbody>
  </Table>
);

export default RsvpTable;



// WEBPACK FOOTER //
// ./src/Welcome/RsvpTable.js